import styled from "styled-components";
import {IoIosArrowBack, IoIosArrowForward} from "react-icons/io";

const Button = ({
                    type = "fill",
                    size = "m",
                    text,
                    onClickFunc,
                    className,
                    icon,
                    dataset,
                    full,
                    brand = false,
                    round = false,
                    capsule = false,
                    disabled = false,
                    arrow = false,
                    prev = false,
                    next = false,
                    styling = undefined,
                }) => {
    return (
        <StyledButton
            onClick={onClickFunc}
            className={`${disabled ? "disabled" : ""} ${className || ""}`}
            data-id={dataset}
            $type={type}
            $size={size}
            $brand={brand}
            $round={round}
            $capsule={capsule}
            $full={full}
            $arrow={arrow}
            $styling={styling}
            disabled={disabled}
        >
            {
                arrow ?
                    <>
                        {
                            prev ?
                                <IoIosArrowBack/>
                                :
                                <IoIosArrowForward/>
                        }
                    </>
                    :
                    <>
                        {icon && (
                            <div className="img-wrap">
                                {typeof icon === "function" && icon()}
                                {typeof icon === "string" && <img src={icon} alt=""/>}
                                {typeof icon !== "string" && typeof icon !== "function" && icon}
                            </div>
                        )}
                        {text}
                    </>
            }

        </StyledButton>
    );
};

const pickPalette = () => {
    return  {
        bg: "#000",
        line: "#111",
        font: "16px",
    };

};

const StyledButton = styled.button`
    .img-wrap {
        margin-right: 8px;
        width: 16px;
        height: 16px;
    }

    overflow: hidden;
    white-space: nowrap;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default Button;
